export function isNotEmpty<T>(x?: T[] | null): boolean {
  return Array.isArray(x) && x.length > 0
}

/**
 * Return a copy of the list that starts at a random item.
 * The other items keep their order.
 */
export function rotateRandomly<T>(items: T[]): T[] {
  const start = Math.floor(Math.random() * items.length)
  return [...items.slice(start), ...items.slice(0, start)]
}
